import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Enroll: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        transform="rotate(-90 12 12)"
        fill={color}
      />
      <path
        d="M8.35446 15L15.5519 15C16.3662 15 16.8391 14.0788 16.3644 13.4171L12.6093 8.18259C12.2003 7.6125 11.3467 7.62983 10.9612 8.21605L7.51893 13.4506C7.08165 14.1155 7.55861 15 8.35446 15Z"
        fill="white"
      />
    </svg>
  );
};

export default Enroll;
